import React, { createContext, useContext, useEffect, useState } from "react";
import api, { getToken, setToken, clearToken } from "../api/client";

const AuthContext = createContext({ admin: null, login: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  // null = checking, false = anonymous, object = authenticated
  const [admin, setAdmin] = useState(getToken() ? null : false);

  useEffect(() => {
    if (!getToken()) return;
    api.get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => { clearToken(); setAdmin(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = () => {
    clearToken();
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
